export const api = 'https://react-food-bn.herokuapp.com';
// http://127.0.0.1:4000
// https://react-food-bn.herokuapp.com